import axios from 'axios';

const BASE_URL = import.meta.env.VITE_BASE_URL;
const DEVELOPMENT_URL = import.meta.env.VITE_DEVELOPMENT_URL;
const PREVIEW_URL = import.meta.env.VITE_PREVIEW_URL;
const POST_FILE_URL = import.meta.env.VITE_POST_FILE_URL;

export const axiosBase = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json; charset=utf-8" },
});

export const axiosDevelopment = axios.create({
  baseURL: DEVELOPMENT_URL,
  headers: { "Content-Type": "application/json; charset=utf-8" },
});

export const axiosPreview = axios.create({
  baseURL: PREVIEW_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, OPTIONS",
    "Access-Control-Allow-Headers": "Content-Type",
    "Content-Type": "application/json; charset=utf-8",
  },
});

export const axiosFile = axios.create({
  baseURL: POST_FILE_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Process-Data": false,
    "Content-Type": false,
    "Data-Type": "xml"
  }
});